import { useState } from 'react';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';
import { MultiSelectChips } from '@/components/shared/multi-select-chips';
import { courseTypesLabels } from '@/constants/catalog/course';
import { CourseTypes } from '@/models/catalog/course';

interface CourseTypesEditDialogProps {
  currentValues: CourseTypes[];
  onClose: () => void;
  onSave: (courseTypes: CourseTypes[]) => void;
}

export const CourseTypesEditDialog = ({
  currentValues,
  onClose,
  onSave,
}: CourseTypesEditDialogProps) => {
  const [courseTypes, setCourseTypes] = useState<CourseTypes[]>(currentValues);

  const handleToggleCourseType = (courseType: CourseTypes) => {
    if (courseTypes.includes(courseType)) {
      setCourseTypes(courseTypes.filter((type) => type !== courseType));
    } else {
      setCourseTypes([...courseTypes, courseType]);
    }
  };

  const handleSave = () => {
    onSave(courseTypes);
  };

  return (
    <ConfirmDialog
      actionLabels={{
        cancel: 'Cancelar',
        confirm: 'Salvar',
      }}
      onClose={onClose}
      open
      onConfirm={handleSave}
      title="Tipos de cursos"
    >
      <MultiSelectChips
        options={Object.values(CourseTypes).map((courseType) => ({
          label: courseTypesLabels[courseType],
          value: courseType,
        }))}
        currentValues={courseTypes}
        onToggle={handleToggleCourseType}
        shouldAnimate={false}
      />
    </ConfirmDialog>
  );
};
